module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/store_images/2_bbff198ca11c8bd6bf33024b790f448d.png";